export const getDisplayValue = (value, arrOption) => {
  const display = arrOption?.filter((elem) => elem?.value === value);
  return display[0]?.display;
};
